<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <h2 class="mb-4">
                        Jonah
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>
                            To understand that God is in control of all things and will carry out his good plans to rescue people.
                        </li>
                        <li>
                            To understand that no-one deserves God’s rescue, but that he wants all people to be saved.
                        </li>
                        <li>
                            To understand that being forgiven by God should make us want to go and tell others about Jesus.
                        </li>
                    </ul>

                    <h5>Series Overview</h5>
                    <p>
                        This series examines the story of Jonah, both his own rescue and the Ninevites’. Together they teach us two great truths about God:
                    </p>
                    <p>
                        God rules – although Jonah tried to run away he could not prevent what God had planned. God was clearly in control of events throughout, halting Jonah’s escape with the storm (week 1); rescuing him by sending the huge fish (week 1); using Jonah’s words to bring the Ninevites to repentance (week 2); and correcting Jonah’s attitude by providing the plant and the worm (week 2).
                    </p>
                    <p>
                        God rescues – with both Jonah and the Ninevites their rescue was undeserved and the result of God’s sovereign grace. Jonah knew this to be true of God and had experienced it first hand, but did not want God to rescue his enemies (weeks 1 and 2). God’s grace and compassion are for all people everywhere, including those who have rejected him (weeks 1 and 2).
                    </p>
                    <p>
                        This story reminds us of the grace that we have received from God in Jesus and should motivate us to want the same grace for others, even those we think don’t deserve it. As Christians we can not only be involved in God’s work of salvation by sharing the good news, we can also be confident that he will achieve his plans.
                    </p>

                    <h5>Series Outline</h5>
                    <p>
                        Lesson 1 - God Rules (Jonah 1:1 – 2:10)
                    </p>
                    <p>
                        Lesson 2 - God Rescues (Jonah 3:1 – 4:11)
                    </p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Jonah",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Jonah`,
            meta: [
                {
                    name: 'description',
                    content: "To understand that God is in control of all things and will carry out his good plans to rescue people.",
                },
            ],
        };
    },
};
</script>
